import React, { FC, useState } from 'react';
import styles from './CancellationRulesMidterm.module.scss';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import Tabs, { Tab } from '@/components/UI/tabs/Tabs';
export const midTermVisitRules = [{
  title: 'قوانین بازدید',
  description: 'از زمان ارسال درخواست تا ۲ روز قبل از شروع اقامت فرصت دارید تا از اقامتگاه بازدید کنید.'
}, {
  title: 'قوانین پرداخت و تسویه',
  description: 'پس از بازدید و تأیید اقامتگاه، برای نهایی شدن رزرو کافیست مبلغ ماه اول اقامت را پرداخت کنید.\n ' + 'مابقی مبلغ رزرو نیز در ابتدای هر ماه اقامت قابل پرداخت خواهد بود.'
}];
export const midtermCancelRules = [{
  title: 'بیشتر از ۲ روز تا شروع اقامت',
  description: 'خسارتی از شما دریافت نمی‌شود.'
}, {
  title: 'کمتر از ۲ روز تا شروع اقامت',
  description: 'کسر مبلغ ۱ شب اقامت (بدون احتساب تخفیف)'
}, {
  title: 'در حین اقامت',
  description: ' کسر مبلغ شب‌های اقامت داشته + مبلغ ۲ شب بعدی اقامت (با احتساب تخفیف)'
}];
type TabsType = 'visit' | 'cancel';
type CancellationRulesProps = {
  handleClose: VoidFunction;
};
const CancellationRulesMidterm: FC<CancellationRulesProps> = ({
  handleClose
}) => {
  const [tabValue, setTabValue] = useState<TabsType>('visit');
  const isVisitTab = tabValue === 'visit';
  const rules = isVisitTab ? midTermVisitRules : midtermCancelRules;
  return <Box className={styles['cancellation-container']} data-sentry-element="Box" data-sentry-component="CancellationRulesMidterm" data-sentry-source-file="CancellationRulesMidterm.tsx">
      <Box className={styles['cancellation-nav']} data-sentry-element="Box" data-sentry-source-file="CancellationRulesMidterm.tsx">
        <Box className={styles['cancellation-header']} data-sentry-element="Box" data-sentry-source-file="CancellationRulesMidterm.tsx">
          <Box className={styles['close-icon']} onClick={handleClose} data-sentry-element="Box" data-sentry-source-file="CancellationRulesMidterm.tsx">
            <Icon name="arrow-right-1" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="CancellationRulesMidterm.tsx" />
          </Box>
          <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="CancellationRulesMidterm.tsx"> قوانین رزرو بلندمدت</Typography>
        </Box>
        <Box className={styles['cancellation-tabs']} data-sentry-element="Box" data-sentry-source-file="CancellationRulesMidterm.tsx">
          <Tabs onChange={newValue => setTabValue(newValue as TabsType)} value={tabValue} data-sentry-element="Tabs" data-sentry-source-file="CancellationRulesMidterm.tsx">
            <Tab label="بازدید و پرداخت" value={'visit'} data-sentry-element="Tab" data-sentry-source-file="CancellationRulesMidterm.tsx" />
            <Tab label="لغو رزرو" value={'cancel'} data-sentry-element="Tab" data-sentry-source-file="CancellationRulesMidterm.tsx" />
          </Tabs>
        </Box>
      </Box>

      <Box className={styles['main-content']} data-sentry-element="Box" data-sentry-source-file="CancellationRulesMidterm.tsx">
        <Box className={styles['rule-card']} data-sentry-element="Box" data-sentry-source-file="CancellationRulesMidterm.tsx">
          <Box className={styles['rule-card-description']} data-sentry-element="Box" data-sentry-source-file="CancellationRulesMidterm.tsx">
            {!isVisitTab && <Box className={styles['wrap']} component={'span'}></Box>}
            <Box className={styles['description-container']} data-sentry-element="Box" data-sentry-source-file="CancellationRulesMidterm.tsx">
              {rules.map((rule, index) => <Box key={`RULE_ITEM_${index}`} component={'ul'} className={styles['description-section']}>
                  <Box className={styles['disc']}></Box>
                  <Box className={styles['description-info']}>
                    <Typography component="li" variant="bodyM_Bold">
                      {rule.title}
                    </Typography>
                    <Typography variant="bodyM" color="neutral_main">
                      {rule.description}
                    </Typography>
                  </Box>
                </Box>)}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>;
};
export default CancellationRulesMidterm;